import { PaymentAgreementRowActions } from 'modules/conciliation/payment-agreement/components/PaymentAgreementRowActions';
import { CellAlign, CellType, HeadCell } from '@dfl/mui-admin-layout';
import { IPaymentAgreement } from 'modules/conciliation/payment-agreement/interfaces';
import { createdATColumn } from 'modules/common/constants/common.columns';
import { PAYMENT_AGREEMENT_PERMISSIONS } from 'modules/conciliation/payment-agreement/constants/payment-agreement.permissions';
import { ReactLink } from '@dfl/react-security';
import { PAYMENT_AGREEMENT_ROUTE } from './payment-agreement-route';
import PaymentAgreementSubOrderRowActions from '../components/PaymentAgreementRowActions/PaymentAgreementSubOrderRowActions';
import { AvatarNameCell } from 'modules/common/components/AvatarNameCell';
import PriceCell from 'modules/security/audit-logs/components/TableCells/PriceCell';

export const paymentAgreementNameColumn: HeadCell<IPaymentAgreement> = {
  field: 'name',
  headerName: 'dispatch:fields.name',
  disablePadding: false,
  renderCell: (name: string, data?: IPaymentAgreement) => (
    <ReactLink to={PAYMENT_AGREEMENT_ROUTE.DETAIL(data?._id as string)} underline='hover'>
      {name}
    </ReactLink>
  ),
};

export const driverColumn: HeadCell<IPaymentAgreement> = {
  field: 'driver.fullName',
  headerName: 'paymentAgreement:fields.driver',
  renderCell: (driver: string, data: IPaymentAgreement) => (
    <AvatarNameCell
      name={driver}
      link={`/inventory/provider/carriers/${data?.carrier?._id as string}/drivers/${data?.driver?._id as string}/general`}
      hideImage
    />
  ),
};

export const carrierColumn: HeadCell<IPaymentAgreement> = {
  field: 'carrier.name',
  headerName: 'common:provider.CARRIER',
  renderCell: (carrier: string, data: IPaymentAgreement) => (
    <AvatarNameCell
      name={carrier}
      link={`/inventory/provider/carriers/${data?.carrier?._id as string}/general`}
      hideImage
    />
  ),
};

export const quantityOrdersColumn: HeadCell<IPaymentAgreement> = {
  field: 'quantityOrders',
  headerName: 'paymentAgreement:fields.quantityOrders',
  type: CellType.NUMBER,
  align: CellAlign.CENTER,
};
export const shippingCostColumn: HeadCell<IPaymentAgreement> = {
  field: 'shippingCost',
  headerName: 'paymentAgreement:fields.shippingCost',
  renderCell: (value: number) => <PriceCell value={value || 0} />,
};

export const sendDateColumn: HeadCell<IPaymentAgreement> = {
  field: 'sendDate',
  headerName: 'paymentAgreement:fields.sendDate',
  type: CellType.DATE,
};

export const paymentAgreementActionsColumn: HeadCell<IPaymentAgreement> = {
  field: 'actions',
  sortable: false,
  width: 100,
  permissions: PAYMENT_AGREEMENT_PERMISSIONS.PAYMENT_AGREEMENT_WRITE,
  headerName: 'common:actions',
  disablePadding: true,
  component: PaymentAgreementRowActions,
};

export const paymentAgreementSubOrderActionsColumn: HeadCell<IPaymentAgreement> = {
  field: 'actions',
  sortable: false,
  width: 100,
  permissions: PAYMENT_AGREEMENT_PERMISSIONS.PAYMENT_AGREEMENT_WRITE,
  headerName: 'common:actions',
  disablePadding: true,
  component: PaymentAgreementSubOrderRowActions,
};

// by payment agreement list
export const paymentAgreementColumns: Array<HeadCell<any>> = [
  paymentAgreementNameColumn,
  carrierColumn,
  driverColumn,
  quantityOrdersColumn,
  shippingCostColumn,
  sendDateColumn,
  createdATColumn,
  paymentAgreementActionsColumn,
];

// by details payment agreement suborder list
export const paymentAgreementSubOrderColumns = (subOrderColumn: any[]) => [
  ...subOrderColumn,
  paymentAgreementSubOrderActionsColumn,
];
